import * as React from 'react';

import { Link } from '@cian/ui-kit';

export interface IPaginationOnClickParams {
  page: number;
  url: string;
}

interface IPaginationLinkProps {
  pageNumber: number;
  url: string;
  onClick: (params: IPaginationOnClickParams) => void;
  children: string;
}

export const PaginationLink: React.FC<IPaginationLinkProps> = ({ pageNumber, url, onClick, children }) => {
  const onLinkClick = React.useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();

      onClick({ page: pageNumber, url });
    },
    [onClick, pageNumber, url],
  );

  return (
    <Link fontSize="M" href={url} onClick={onLinkClick}>
      {children}
    </Link>
  );
};
